import React from 'react';

import CasinoMaintenanceContainer from 'components/MaintenanceContainer/CasinoMaintenanceContainer';
import CasinoRouter from 'components/Pages/Casino/CasinoRouter';
import { QuickDepositBonusesProvider } from 'src/common/Popup/QuickDepositPopup/QuickDepositBonusesProvider';

const MainCasino = () => (
  <CasinoMaintenanceContainer>
    <QuickDepositBonusesProvider>
      <CasinoRouter />
    </QuickDepositBonusesProvider>
  </CasinoMaintenanceContainer>
);

export default MainCasino;
